export default "__VITE_ASSET__CgK8jWJR__"